// extracted by mini-css-extract-plugin
module.exports = {"content":"TeamSuccessRateStats_content__mQI_c","table":"TeamSuccessRateStats_table__LOoo0"};